// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  itemId: __t.u64().name("item_id"),
  discountPercent: __t.u32().name("discount_percent"),
  dealDate: __t.u64().name("deal_date"),
  slotIndex: __t.u32().name("slot_index"),
  purchased: __t.bool(),
});
